export const IDTypes = [
  {
    label: "INE/IFE",
    value: "ine",
    description: "Credencial para votar vigente",
  },
  {
    label: "Pasaporte mexicano",
    value: "passport",
    description: "Pasaporte mexicano vigente",
  },
  {
    label: "Licencia de conducir",
    value: "driver_license",
    description: "Licencia vigente del estado de Jalisco",
  },
  {
    label: "Forma Migratoria",
    value: "migratory_form",
    description: "Para extranjeros residentes en México",
  },
];

export const maxAllowedFiles: Record<string, number> = {
  ine: 2,
  passport: 1,
  driver_license: 2,
  migratory_form: 2,
  proof_of_address: 1,
  proof_of_income: 1,
  sat_opinion: 1,
  boleta_registral: 1,
  predial: 1,
  power_of_attorney: 1,
  business_act: 1,
};

export const labelIDOptions: Record<string, string> = {
  tenant: "inquilino",
  guarantor: "obligado solidario",
  legal_rep: "representante legal",
  landlord: "propietario",
  owner_rep: "representante del propietario",
};

export const labelFileDropOptions: Record<string, string> = {
  none: "",
  ine: "INE/IFE",
  passport: "pasaporte",
  driver_license: "licencia de conducir",
  migratory_form: "forma migratoria",
};

export const listIDOptions = [
  { title: "Opción 1: INE/IFE" },
  { title: "Opción 2: Pasaporte mexicano" },
  { title: "Opción 3: Licencia de conducir" },
  { title: "Opción 4 (extranjeros): Forma Migratoria" },
];
